import { render, staticRenderFns } from "./OrderActive.vue?vue&type=template&id=28ea4838&"
import script from "./OrderActive.vue?vue&type=script&lang=js&"
export * from "./OrderActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports